import { render, staticRenderFns } from "./ModalUpdateUpgrade.vue?vue&type=template&id=ee6d24f2"
import script from "./ModalUpdateUpgrade.vue?vue&type=script&lang=js"
export * from "./ModalUpdateUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports